import React from 'react';
import PropTypes from 'prop-types';
import { useLabels, useSitemap } from 'wsm-common-data';
import DistanceSelector from './DistanceSelector';

const SITEMAP_KEY = 'LIST_ALL_LOCATIONS';

const NoResultsContent = ({ currentRange, onRangeChange }) => {
	const labels = useLabels();
	const sitemap = useSitemap();

	const searchDistanceText = labels.get('SEARCH_TRY_INCREASING_DISTANCE');
	const allLocationText = labels.get('LOCATIONS_VIEW_ALL');
	const allLocHref = sitemap.get(SITEMAP_KEY);

	return (
		<div className="d-flex flex-column align-items-center">
			<p className="mb-4">{searchDistanceText}</p>

			<DistanceSelector
				currentRange={currentRange}
				onRangeChange={onRangeChange}
			/>

			<div className="my-3 text-muted">
				<span>or</span>
			</div>

			<div>
				<a href={allLocHref} className="btn btn-link text-primary">
					{allLocationText}
				</a>
			</div>
		</div>
	);
};

NoResultsContent.propTypes = {
	currentRange: PropTypes.number,
	onRangeChange: PropTypes.func
};

export default NoResultsContent;
